/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../shared/images/teambuildr-selection.json';
import { ColorPrimary } from '../../../shared/GlobalStyles';

const CloseButton = styled('button')`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 12px;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 12px;
  z-index: 100;
`;

const InnerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ModalWrapper = styled('div')`
  display: flex;
  font-family: 'Nunito Sans';
  max-height: 80vh;
  width: 100%;
  .react-player {
    border-radius: 12px;
    left: 0;
    position: absolute;
    top: 0;
    video {
      border-radius: 12px;
    }
  }
  @media screen and (max-width: 440px) {
    max-width: 380px;
  }
`;

const PlayerWrapper = styled('div')`
  padding-top: 56.25%;
  position: relative;
`;

const MediaModalContent = ({ onRequestClose, mediaUrl }) => (
  <ModalWrapper>
    <CloseButton aria-label='Close modal' onClick={onRequestClose}>
      <IcomoonReact
        iconSet={iconSet}
        size={14}
        icon='remove'
        color={ColorPrimary}
        aria-hidden='true'
      />
    </CloseButton>
    <InnerWrapper>
      <PlayerWrapper>
        <ReactPlayer
          className='react-player'
          url={mediaUrl}
          controls
          width='100%'
          height='100%'
          playing
          style={{ backgroundColor: ColorPrimary }}
        />
      </PlayerWrapper>
    </InnerWrapper>
  </ModalWrapper>
);

MediaModalContent.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  mediaUrl: PropTypes.string.isRequired,
};

export default MediaModalContent;
